import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class BatchPrintListItem extends SearchModelBase {
    id: number = 0;
    docType: string = '';              // 'INV' | 'CRDB' — View 링크 경로를 정할 때 사용
    actionDate: string = '';
    fromActionDate: string = '';
    toActionDate: string = '';
    actionUser: string = '';
    emailTemplate: string = '';
    rangeType: string = '';            // 'Date' | 'Number'
    rangeFrom: string = '';
    rangeTo: string = '';
    branch: string = '';
    totalCount: number = 0;
    fromTotalCount: number = 0;
    toTotalCount: number = 0;
    sentCount: number = 0;
    fromSentCount: number = 0;
    toSentCount: number = 0;
    failedCount: number = 0;
    fromFailedCount: number = 0;
    toFailedCount: number = 0;
    skippedCount: number = 0;
    fromSkippedCount: number = 0;
    toSkippedCount: number = 0;
    stopped: string = '';              // 'Y' | ''

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Action Date', width: 150, dataIndex: 'actionDate', type: XCol.XCellType.DateTime, defaultColumnFocus: true }),
        XCol.Create({ col: 1, text: 'User', width: 100, dataIndex: 'actionUser' }),
        XCol.Create({ col: 2, text: 'Email Template', width: 220, dataIndex: 'emailTemplate' }),
        XCol.Create({ col: 3, text: 'Range Type', width: 80, dataIndex: 'rangeType' }),
        XCol.Create({ col: 4, text: 'From', width: 100, dataIndex: 'rangeFrom' }),
        XCol.Create({ col: 5, text: 'To', width: 100, dataIndex: 'rangeTo' }),
        XCol.Create({ col: 6, text: 'Branch', width: 60, dataIndex: 'branch', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 7, text: 'Total', width: 70, dataIndex: 'totalCount', type: XCol.XCellType.Double, formatString: '#,##0' }),
        XCol.Create({ col: 8, text: 'Sent', width: 70, dataIndex: 'sentCount', type: XCol.XCellType.Double, formatString: '#,##0' }),
        XCol.Create({ col: 9, text: 'Failed', width: 70, dataIndex: 'failedCount', type: XCol.XCellType.Double, formatString: '#,##0' }),
        XCol.Create({ col: 10, text: 'Skipped', width: 70, dataIndex: 'skippedCount', type: XCol.XCellType.Double, formatString: '#,##0' }),
        XCol.Create({ col: 11, text: 'Stopped', width: 70, dataIndex: 'stopped', align: XCol.XAlignType.Center }),
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };

    public static OrderBy = { orderBy: BatchPrintListItem.prototype.actionDate, orderByAscending: true };

    public static formatData(data: BatchPrintListItem[]) {
        return data.map((d: BatchPrintListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        actionDate: {from: 'fromActionDate', to: 'toActionDate'},
        totalCount: {from: 'fromTotalCount', to: 'toTotalCount'},
        sentCount: {from: 'fromSentCount', to: 'toSentCount'},
        failedCount: {from: 'fromFailedCount', to: 'toFailedCount'},
        skippedCount: {from: 'fromSkippedCount', to: 'toSkippedCount'},
    }
}